import React, { useState, useEffect, useRef  } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row, Table } from 'react-bootstrap';
import { RadioButton } from 'primereact/radiobutton';
import CityCombo from '../combos/CityCombo';
import { Checkbox } from 'primereact/checkbox';

export default function PromoteContractMudules(props) {
    const navigate = useNavigate();
    const [contract, setContract] = useState(null);
    const [modules, setModules] = useState([]);
    const [modulePrice, setModulePrice] = useState(0);
    const [tax, setTax] = useState(0);
    const [purePrice, setPurePrice] = useState(0);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const targetRef1 = useRef(null);

    useEffect(() => {
        util.scrollToElement(targetRef1, "start");
        var contract = util.getClientContract();
        console.log("contract is>", contract);
        var modules = [];
        var ms = [];
        var buy = util.getBuy();
        if(buy != null){
            for(var i=0;i<buy.modules.length;i++){
                ms.push(buy.modules[i].code);
            }
        }

        var sum = 0;
        for(var i=0;i<contract.promoteAbleModules.length;i++){
            modules.push({
                isChecked:ms.includes(contract.promoteAbleModules[i].code), 
                code:contract.promoteAbleModules[i].code, 
                title:contract.promoteAbleModules[i].title, 
                price:contract.promoteAbleModules[i].price
            });
            if(ms.includes(contract.promoteAbleModules[i].code)){
                sum += contract.promoteAbleModules[i].price;
            }
        }
        setModulePrice(sum);
        var tx = Math.floor((sum * contract.taxPercent)/100);
        setTax(tx);
        setPurePrice(sum + tx);
        setContract(contract);
        setModules(modules);
        
    }, []);
    const checkDataEntry = function(){
        for(var i=0;i<modules.length;i++){
            if(modules[i].isChecked) return true;
        }
        setErorVisible(true);
        setErrorMessage("هیچ ماژولی انتخاب نشده است");
        return false;
    }
    const onContinueButtonClick = function(){
        if(!checkDataEntry()) return;
        var ms = [];
        for(var i=0;i<modules.length;i++){
            if(modules[i].isChecked) ms.push(modules[i].code)
        }
        var buy = {
            productId:contract.contract.id,
            enName:contract.contract.product.enName,
            buyGoal:"promoteModule",
            productType:0,
            modules:ms,
            parameters :{
                maxClientNo:0,
                maxVisitorNo:0,
                maxStudentNo:0,
                maxSchoolNo:0,
                maxMemberNo:0,
                maxBillNo:0
            },
            price:purePrice,
            discountToken:"",
            discountMobile:"",

        };
        util.saveBuy(buy);        
        
        util.saveIpgTransactionAmount(purePrice);
        util.saveIpgTransactionType(util.WallerTransactionTypes.PromoteContractModule);
        util.saveBeforeIpgUrl("PromoteContractModule");
        setRedirectUrl("/ipg/select");
    }
    const onModuleCheckChanged = (code, value, ind) => {
        var res = [...modules];
        res[ind].isChecked = !value;
        setModules(res);
        var sum = 0;
        for(var i=0;i<res.length;i++){
            if(res[i].isChecked){
                sum += res[i].price;
            }
        }
        setModulePrice(sum);
        var tx = Math.floor((sum * contract.taxPercent)/100);
        setTax(tx);
        setPurePrice(sum + tx);
    };    

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        contract == null?
        <>
            بارگذاری قرارداد...
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}} ref={targetRef1}>                
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <img src={require("../lib/images/back.png")} alt='برگشت' onClick={()=>{navigate("/my-contracts/list")}} style={{width:"48px", height:"32px", position:"absolute", top:"5px", right:"10px", cursor:"pointer"}} />
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>انتخاب ماژول ها جهت ارتقاء قرارداد</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td>
                                        <div style={{padding:"5px"}}>شما محصول [<label style={{color:"rgb(8, 106, 8)", fontWeight:"bold"}}>{contract.contract.product.productType.title}</label>] را انتخاب نموده اید</div>
                                        <div style={{padding:"5px"}}>ماژول های مورد نیاز را نیز انتخاب کنید</div>
                                        <Table hover striped key={"moduletable"}>
                                            <tbody  key={"moduletablebody"}>
                                            {
                                                modules.map((m, mInd)=>{
                                                    return(
                                                        <tr key={"tr_" + String(mInd)}>
                                                            <td style={{borderBottom:"0px"}} key={"td1_" + String(mInd)}>
                                                                <div key={"divCheckBox_"+String(mInd)} className="flex align-items-center">
                                                                    <Checkbox disabled={false} value={m.isChecked} inputId={"chkModule_"+String(mInd)} onChange={(e)=>onModuleCheckChanged(m.code, e.value, mInd)} checked={m.isChecked} />
                                                                    <label htmlFor={"chkModule_"+String(mInd)} className="ml-2">&nbsp;{m.title}</label>
                                                                </div>
                                                            </td>
                                                            <td style={{borderBottom:"0px"}} key={"td2_" + String(mInd)}>
                                                                {util.SeperatePrice(m.price)}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </Table>
                                        <table style={{width:"100%"}}>
                                            <tbody>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>جمع ماژول ها</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(modulePrice)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>ارزش افزوده</td>
                                                    <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(tax)}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"left", padding:"10px", border:"1px dashed #b0b0b0", borderRight:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>جمع کل</td>
                                                    <td style={{textAlign:"right", padding:"10px", border:"1px dashed #b0b0b0", borderLeft:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>{util.SeperatePrice(purePrice)}</td>
                                                </tr>
                                            </tbody>
                                        </table> 

                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}} loading={saving} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;تائید و ادامه&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}